import useAuth from '../hooks/useAuth';

class ApiService {
    constructor() {
        this.baseUrl = process.env.REACT_APP_API_BASE || "/api";
    }

    async register(username, email, password, role="user") {
        console.log(username)
        try {
            const url = `${this.baseUrl}/user/register`;
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ username, email, password, role }),
            });

            if (!response.ok) {
                let response_message;
                try {
                    response_message = await response.json();
                } catch (e) {
                    response_message = { detail: `Registration failed with status ${response.status}` };
                }
                throw new Error(response_message.detail || `Registration failed with status ${response.status}`);
            }

            return await response.json();

        } catch (error) {
            console.error("Error during registration:", error);
            throw error;
        }
    }
    async login(email, password) {
        try {
            const url = `${this.baseUrl}/user/login`;
            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email, password }),
            });

            if (!response.ok) {
                let response_message = await response.json();
                throw new Error(response_message.detail);
            }

            return response.json();
        } catch (error) {
            console.error("Error logging in:", error);
            throw error;
        }
    }

    async updateGeom(geomId, updatedGeom) {
        return this.apiCall(`/geom/${geomId}`, "PUT", updatedGeom);
    }

    async createGeom(geom) {
        return this.apiCall(`/geom`, "POST", geom);
    }

    async getGeom(geomId) {
        return this.apiCall(`/geom/${geomId}`, "GET");
    }

    async getGeoms() {
        return this.apiCall(`/geom/`, "GET");
    }

    async sendRequest(payload) {
        return this.apiCall(`/cmmi/`, "POST", payload);
    }

    async fetchUserRequests(geometryId = null, startDate = null, endDate = null) {
        let endpoint = `/cmmi/`; 
        const queryParams = new URLSearchParams(); 

        if (geometryId !== null && geometryId !== 'all') {
            queryParams.append('geom_id', geometryId);
        }

        if (startDate) {
            const formattedStartDate = startDate instanceof Date ? startDate.toISOString() : startDate;
            queryParams.append('start_date', formattedStartDate);
        }

        if (endDate) {
            const formattedEndDate = endDate instanceof Date ? endDate.toISOString() : endDate;
            queryParams.append('end_date', formattedEndDate);
        }

        const queryString = queryParams.toString();
        if (queryString) {
            endpoint += `?${queryString}`;
        }

        return this.apiCall(endpoint, "GET");
    }

    async downloadReport(requestId) {
        try {
            const token = localStorage.getItem('token');
            const url = `${this.baseUrl}/cmmi/${requestId}/report`;
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                let errorMessage = "Unable to download report.";
                try {
                    const errorPayload = await response.json();
                    if (errorPayload?.detail) {
                        errorMessage = errorPayload.detail;
                    }
                } catch (_) {
                    // Ignore JSON parse errors, fall back to default message
                }
                throw new Error(errorMessage);
            }

            const blob = await response.blob();
            const disposition = response.headers.get("Content-Disposition") || response.headers.get("content-disposition");
            let filename = `MSP4GROWTH_Report_${requestId}.pdf`;
            if (disposition) {
                const match = disposition.match(/filename="?([^"]+)"?/);
                if (match && match[1]) {
                    filename = match[1];
                }
            }

            return { blob, filename };
        } catch (error) {
            console.error("Error downloading report:", error);
            throw error;
        }
    }

    async deleteRequest(requestId) {
        const res = await this.apiCall(`/cmmi/${encodeURIComponent(requestId)}`, 'DELETE');
        if (!res) throw new Error('Unauthorized or no response from server');
        if (res.status !== 204 && !res.ok) {
            const txt = await res.text().catch(() => '');
            throw new Error(`Delete failed: ${res.status} ${txt}`);
        }
        return true;
    }

    async apiCall(endpoint, method, body = null) {
        try {
            const token = localStorage.getItem('token');
            const url = `${this.baseUrl}${endpoint}`;
            const headers = {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            };
            const config = {
                method,
                headers,
            };
            if (body) {
                config.body = JSON.stringify(body);
            }

            const response = await fetch(url, config);

            if (response.status === 401) {
                localStorage.removeItem('token');
                return;
            }

            if (!response.ok) {
                console.log(Error(`HTTP error! status: ${response.status}`));
            }
            if (method === "GET") {
                return await response.json();
            }
            return response;
        } catch (error) {
            console.error(`Error during ${method} to ${endpoint}:`, error);
            throw error;
        }
    }
}

export default new ApiService();
